import { useCallback, useEffect, useState } from 'react';
import { NumberProperty as NumberProp } from '../../peregrineFlowInterfaces';
import { NodePropertyProp } from '../NodePropertyPane';
import { TextField, Box, Typography, Tooltip } from '@mui/material';
import { HelpOutline } from '@mui/icons-material';

function NumberProperty({ property, onChange }: NodePropertyProp) {
    const p = property as unknown as NumberProp;
    const [value, setValue] = useState<number>(p.value);

    useEffect(() => {
        setValue(p.value)
    }, [p])

    const onValueChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        p.value = parseFloat(event.target.value);
        onChange?.(p);
        setValue(p.value);
    }, [p, onChange]);

    return (
        <Box sx={{ width: '100%' }}>
            <Box display="flex" alignItems="center">
                <Typography variant="caption">{p.label}</Typography>
                {p.description && (
                    <Tooltip title={<div style={{ whiteSpace: 'pre-line' }}>{p.description}</div>} componentsProps={{ tooltip: { sx: { maxWidth: 'none' } } }}>
                        <HelpOutline fontSize="small" sx={{ ml: 1, color: 'text.secondary', cursor: 'help', width: 16, height: 16 }} />
                    </Tooltip>
                )}
            </Box>
            <TextField
                fullWidth
                defaultValue={value}
                variant="outlined"
                type="number"
                onChange={onValueChange}
                inputProps={{
                    min: p.min !== undefined ? p.min : "",
                    max: p.max !== undefined ? p.max : "",
                    step: p.step !== undefined ? p.step : ""
                }}
            />
        </Box>
    )
}

export default NumberProperty;
